const HTML_MAIL_RECU_DEFAUT =
  '<p>{Civilite_payeur} {Nom_payeur},</p>' +
  '<p><br></p>' +
  "<p>Veuillez trouver ci-joint votre reçu n° <strong>{Numero_recu}</strong> d'un montant de <strong>{Montant_recu}</strong> €, en date du {Date_recu}.</p>" +
  '<p><br></p>' +
  '<p>Il vous est délivré par la {Nom_regie} pour le paiement des factures suivantes :</p>' +
  '<p><br></p>' +
  '<p>{Factures_concernees}</p>' +
  '<p><br></p>' +
  '<p><br></p>' +
  '<p>Pour toute question, adressez-vous à :</p>' +
  '<p><br></p>' +
  '<p>{Nom_regie}</p>' +
  '<p>{Adresse_regie}</p>' +
  '<p>{Telephone_regie}</p>' +
  '<p>{Courriel_regie}</p>' +
  '<p><br></p>' +
  "<p>Horaires d'ouverture :</p>" +
  '<p>{Horaires_ouverture}</p>' +
  '<p><br></p>' +
  '<p><br></p>' +
  '<p>Cordialement,</p>' +
  '<p>{Nom_regisseur}, {Type_regisseur}</p>';

export default HTML_MAIL_RECU_DEFAUT;
